import React from 'react'
import './style.scss'
import bannerImageLeft from 'assets/shop/banner-left.png'

function Banner() {
  return (
    <div className="banner">
      <div className="banner-left">
        <img src={bannerImageLeft} alt="bannerImageLeft" />
      </div>
      <div className="banner-right">
        <span className="content-top">
          Young generation (with) <br /> a Dream
        </span>
        <span className="content-bottom">Ad Meliora</span>
      </div>
    </div>
  )
}

export default Banner
